/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

const useStyles = makeStyles((theme) => ({
  frr_tabs_bg: {
    backgound: 'transparent',
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));
export default function ColorTabs(props) {
  const classes = useStyles();

  const {
    tabValue,
    handleChangeTabValue,
    errorMessagesArray,
    labelersTabError,
    manufacturerDetailTabError,
    contactTabError,
    bankruptcyTabError,
    CreateManufacturer,
  } = props;
  return (
    <>
      <div
        data-testid="mfg-tabs"
        className={`${classes.root} ${classes.frr_tabs_bg}`}
      >
        <AppBar position="static">
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color="red"
            style={{
              color: 'red',
              backgroundColor: 'transparent',
            }}
          >
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="one"
              label="Labelers"
              tabIndex={0}
            />
            {labelersTabError &&
              errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.filter((x) => {
                return (
                  x === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
                  x === constantMessageData.MFG_LABELER_END_DATE_ERROR ||
                  x === constantMessageData.MFG_START_DATE_ERROR ||
                  x === constantMessageData.START_DATE_REQUIRED
                );
              }).length > 0 && <span className="tab-error">!</span>}
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="two"
              label="Details"
              tabIndex={0}
            />
            {(manufacturerDetailTabError ||
              (errorMessagesArray &&
                errorMessagesArray.length > 0 &&
                errorMessagesArray.filter((x) => {
                  return x === constantMessageData.QUARTER_FORMAT_ERROR;
                }).length > 0)) && <span className="tab-error">!</span>}
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="three"
              label="Contacts"
              tabIndex={0}
            />{' '}
            {errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.filter((x) => {
                return (
                  x.includes(constantMessageData.ZIP4_REQUIRED) ||
                  x.includes(constantMessageData.PHONE_INVALID_ERROR) ||
                  x.includes(constantMessageData.EMAIL_INVALID) ||
                  x.includes(constantMessageData.MFG_CONTACT_DETAILS_ERROR)
                );
              }).length > 0 && <span className="tab-error">!</span>}
            {!props.CreateManufacturer ? (
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="four"
                label="Bankruptcy"
                tabIndex={0}
              />
            ) : null}
            {bankruptcyTabError &&
              errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.filter((x) => {
                return (
                  x === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
                  x === constantMessageData.START_DATE_REQUIRED ||
                  x === constantMessageData.MFG_BANKRUPTCY_END_DATE_ERROR ||
                  x === constantMessageData.MFG_START_DATE_ERROR ||
                  x.includes(
                    constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR
                  )
                );
              }).length > 0 && <span className="tab-error">!</span>}
            <Tab
              disabled={CreateManufacturer}
              style={{ textTransform: 'capitalize' }}
              value="five"
              label="Contracts"
              tabIndex={0}
            />
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
